<router-outlet>
  <div></div>

  <div class="text"style="d-flex justify-content-center">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

  </div>
<div class="center"><app-loaders></app-loaders></div>

</router-outlet>

<!-- Fork Test 01-->